import React, { useState, useEffect, useContext } from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  TextField, Button, Grid, Snackbar, Alert, MenuItem, FormControl, InputLabel, Select
} from "@mui/material";
import { ThemeContext } from "../../../../../../../../context/ThemeContextProvider";
import {  fetchCaptains } from "../../../../../../../../services/pos/Tables";
import { useOrder } from "../../../../../../../../context/OrderCreator/TablesContext/OrderContext";

const EditOrderForm = ({ open, onClose, initialData }) => {
  const { mode } = useContext(ThemeContext);
  const [form, setForm] = useState({});
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");
  const [captains, setCaptains] = useState([]);
  const { updateOrderData } = useOrder();


  useEffect(() => {
    if (initialData) setForm(initialData);
  }, [initialData]);

  useEffect(() => {
    if (open) {
      fetchCaptains()
        .then((data) => setCaptains(data))
        .catch((err) => setCaptains([]));
    }
  }, [open]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    try {
      if (!form.order_id) throw new Error("❌ رقم الأوردر غير موجود");

      await updateOrderData(form.order_id, {
        captain_order_id: form.captain_order_id,
        table_id: form.table_id || "",
        customer_id: form.customer_id || form.customer?.id || "",
      });

      setSuccess(true);
      onClose(true);
    } catch (err) {
      setError(err.message || "❌ فشل في التعديل");
    }
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={() => onClose(false)}
        fullWidth
        PaperProps={{
          sx: {
            bgcolor: mode === "dark" ? "#232334" : "#fff",
            color: mode === "dark" ? "#fff" : "#232334",
            borderRadius: 3,
          },
        }}
      >
        <form
          onSubmit={(e) => {
            e.preventDefault();
            handleSubmit();
          }}
        >
          <DialogTitle
            sx={{
              fontWeight: 700,
              fontSize: 22,
              textAlign: "center",
              color: "#EA7C69",
              bgcolor: mode === "dark" ? "#181824" : "#fff",
              borderRadius: "16px 16px 0 0",
            }}
          >
            تعديل بيانات الكابتن
          </DialogTitle>
          <DialogContent
            dividers
            sx={{
              bgcolor: mode === "dark" ? "#232334" : "#fff",
              pb: 2,
            }}
          >
            <Grid container spacing={2} mt={1}>
              <Grid item xs={12}>
                <FormControl fullWidth sx={{ bgcolor: mode === "dark" ? "#181824" : "#fff", borderRadius: 2 }}>
                  <InputLabel sx={{ color: mode === "dark" ? "#aaa" : undefined }}>اختر الكابتن</InputLabel>
                  <Select
                    label="اختر الكابتن"
                    name="captain_order_id"
                    value={form.captain_order_id || ""}
                    onChange={handleChange}
                    sx={{
                      color: mode === "dark" ? "#fff" : "#232334",
                      ".MuiOutlinedInput-notchedOutline": {
                        borderColor: mode === "dark" ? "#444" : "#ccc",
                      },
                    }}
                    MenuProps={{
                      PaperProps: {
                        sx: {
                          bgcolor: mode === "dark" ? "#232334" : "#fff",
                          color: mode === "dark" ? "#fff" : "#232334",
                        },
                      },
                    }}
                  >
                    {captains.map((captain) => (
                      <MenuItem key={captain.id} value={captain.id}>
                        {captain.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions sx={{ bgcolor: mode === "dark" ? "#232334" : "#fff", borderRadius: "0 0 16px 16px" }}>
            <Button
              onClick={() => onClose(false)}
              variant="outlined"
              color="secondary"
              sx={{
                minWidth: 100,
                borderColor: mode === "dark" ? "#888" : undefined,
                color: mode === "dark" ? "#fff" : undefined,
              }}
            >
              إلغاء
            </Button>
            <Button
              variant="contained"
              type="submit"
              sx={{
                bgcolor: "#EA7C69",
                color: "#fff",
                minWidth: 120,
                fontWeight: 700,
                "&:hover": { bgcolor: "#d45d4c" },
              }}
            >
              حفظ التعديلات
            </Button>
          </DialogActions>
        </form>
      </Dialog>

      <Snackbar open={!!error} autoHideDuration={3000} onClose={() => setError("")}>
        <Alert severity="error">{error}</Alert>
      </Snackbar>
      <Snackbar open={success} autoHideDuration={3000} onClose={() => setSuccess(false)}>
        <Alert severity="success">✅ تم التعديل بنجاح</Alert>
      </Snackbar>
    </>
  );
};

export default EditOrderForm;
